import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ProgressSteps from '../components/ToolBox/ProgressSteps';
import Step1_FileUpload from '../components/ToolBox/DoctorScheduleImporter/Step1_FileUpload';
import Step2_Review from '../components/ToolBox/DoctorScheduleImporter/Step2_Review';
import Step3_Complete from '../components/ToolBox/DoctorScheduleImporter/Step3_Complete';

const DoctorScheduleImporter = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [currentStep, setCurrentStep] = useState(0);
  const [fileData, setFileData] = useState(null);
  const [clid, setClid] = useState(searchParams.get('clid') || '');
  const [importSummary, setImportSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleStep1Next = (data) => {
    if (!data) {
      setError('Please upload a valid JSON file');
      return;
    }
    setFileData(data);
    setError('');
    setCurrentStep(1);
  };

  const handleStep2Complete = (summary) => {
    if (summary?.success) {
      setLoading(false);
      setImportSummary(summary);
      if (summary.clid) {
        setClid(summary.clid);
      }
      setCurrentStep(2);
    }
  };

  const handleRestartFlow = () => {
    setCurrentStep(0);
    setFileData(null);
    setClid(searchParams.get('clid') || '');
    setImportSummary(null);
    setError('');
  };

  const goToStep = (step) => {
    setCurrentStep(step);
    setError('');
  };

  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Doctor Schedule Importer</h1>
          <p className="text-gray-600">Import doctors and schedules from JSON file. The JSON can be exported from Clinic Config, THEN Export, THEN Export Clinic Config.</p>
        </div>

        <ProgressSteps currentStep={currentStep} totalSteps={3} />

        {/* Step 1: File Upload */}
        {currentStep === 0 && (
          <Step1_FileUpload
            onNext={handleStep1Next}
            loading={loading}
            error={error}
            setError={setError}
          />
        )}

        {/* Step 2: Review */}
        {currentStep === 1 && (
          <Step2_Review
            fileData={fileData}
            clid={clid}
            onBack={() => goToStep(0)}
            onComplete={handleStep2Complete}
            loading={loading}
            error={error}
            setLoading={setLoading}
            setError={setError}
          />
        )}

        {/* Step 3: Complete */}
        {currentStep === 2 && (
          <Step3_Complete
            summary={importSummary}
            clid={clid}
            onRestart={handleRestartFlow}
          />
        )}
      </div>
    </div>
  );
};

export default DoctorScheduleImporter;
